import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import LoginIcon from '@mui/icons-material/Login';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Button, Grid } from '@mui/material';
import { userMenuOptions, OptionType } from '../menu-options';
import { useAuth } from 'react-oidc-context';
import AppRoutes from 'src/features/router/data/app-routes';
import { useTranslation } from 'react-i18next';

const UserLogin = () => {
    const auth = useAuth();

    const onLogin = async () => {
        await auth.signinRedirect();
    };
    return (
        <Button color="inherit" startIcon={<LoginIcon />} onClick={onLogin}>
            Log in
        </Button>
    );
};

const UserInfo = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const username = auth.user?.profile.name || 'A';
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElUser(null);
    };

    const handleItemClick = async (option: OptionType) => {
        setAnchorElUser(null);
        switch (option.path) {
            case AppRoutes.logoutPath:
                await auth.removeUser();
                await auth.signoutRedirect();
                navigate(AppRoutes.rootPath);
                break;
            default:
                navigate(option.path);
                break;
        }
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Tooltip title={username}>
                <div>
                    <Typography
                        sx={{
                            display: 'inline-block',
                        }}
                        mr={2}
                    >
                        {t('hello')}, {username}
                    </Typography>
                    <IconButton
                        onClick={handleOpen}
                        sx={{ p: 0, display: 'inline-block' }}
                        size="large"
                        aria-label="user menu"
                        aria-controls="menu-user"
                        aria-haspopup="true"
                        color="inherit"
                    >
                        <Avatar alt={username} src="" />
                    </IconButton>
                </div>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleClose}
            >
                {userMenuOptions.map((option) => (
                    <MenuItem key={option.name} onClick={() => handleItemClick(option)}>
                        <Grid container spacing={0.5}>
                            <Grid item xs={4}>
                                {option.icon}
                            </Grid>
                            <Grid item xs={8}>
                                <Typography textAlign="center">{option.name}</Typography>
                            </Grid>
                        </Grid>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

const UserMenu = () => {
    const auth = useAuth();
    return auth.isAuthenticated ? <UserInfo /> : <UserLogin />;
};

export default UserMenu;
